<template>
  <div>
    <Mainlayout></Mainlayout>
    <!-- badan page -->
    <CCard style="z-index:auto" class="h-100 content">
      <CCol sm="12" class="justify-content-center m-0">
        <CContainer>
          <CCol sm="12" lg="12" class="custom-margin mt-5">
            <strong
              >These are list of subjects. each subjects contains a variety of
              quiz that you can choose.</strong
            >
            <br /> <br />
            <CInput style="width: 100%; position: relative; z-index: auto" type="text" placeholder="Search for Quiz Id e.g. 101" v-model="QuizId">
               <template #append-content><span @click="GotoPageQuiz()"><CIcon name="cil-magnifying-glass"/></span></template>
            </CInput>
            <br /> 
            <CCard
              v-for="item in quizStudList"
              v-bind:key="item.subjectId"
              style="background: #ebedef; border: 1px solid #009688"
              body-wrapper
              class="box-shadow"
              @click="GoToPageQuizList(item.subjectId)"
            >
              <CRow>
                <div class="col-3">
                  <div v-if="item.subjectName == 'Mathematics'">
                    <img
                      src="../assets/img/maths.png"
                      width="50px"
                      class="mt-3"
                    />
                  </div>
                  <div v-else-if="item.subjectName == 'Additional Mathematics'">
                    <img
                      src="../assets/img/iconaddmath.png"
                      width="50px"
                      class="mt-3"
                    />
                  </div>
                  <div v-else-if="item.subjectName == 'Science'">
                    <img
                      src="../assets/img/science.png"
                      width="50px"
                      class="mt-3"
                    />
                  </div>
                  <div v-else-if="item.subjectName == 'Physics'">
                    <img
                      src="../assets/img/physics.png"
                      width="50px"
                      class="mt-3"
                    />
                  </div>
                  <div v-else-if="item.subjectName == 'Chemistry'">
                    <img
                      src="../assets/img/chemistry.png"
                      width="50px"
                      class="mt-3"
                    />
                  </div>
                  <div v-else-if="item.subjectName == 'Biology'">
                    <img
                      src="../assets/img/iconbiology.png"
                      width="50px"
                      class="mt-3"
                    />
                  </div>
                  <div v-else-if="item.subjectName == 'Sejarah'">
                    <img
                      src="../assets/img/iconhistory.png"
                      width="50px"
                      class="mt-3"
                    />
                  </div>
                  <div v-else-if="item.subjectName == 'Geografi'">
                    <img
                      src="../assets/img/icongeography.png"
                      width="50px"
                      class="mt-3"
                    />
                  </div>

                  <div
                    v-else-if="
                      item.subjectName ==
                      'Information and Communication Technology'
                    "
                  >
                    <img
                      src="../assets/img/iconit.png"
                      width="50px"
                      class="mt-3"
                    />
                  </div>
                  <div v-else-if="item.subjectName == 'Bahasa Inggeris'">
                    <img
                      src="../assets/img/iconenglish.png"
                      width="50px"
                      class="mt-3"
                    />
                  </div>

                  <div v-else-if="item.subjectName == 'Additional Science'">
                    <img
                      src="../assets/img/addscience.png"
                      width="50px"
                      class="mt-3"
                    />
                  </div>

                  <div v-else-if="item.subjectName == 'Prinsip Perakaunan'">
                    <img
                      src="../assets/img/iconaccount.png"
                      width="50px"
                      class="mt-3"
                    />
                  </div>

                  <div v-else-if="item.subjectName == 'Literature in English'">
                    <img
                      src="../assets/img/iconliterature.png"
                      width="50px"
                      class="mt-3"
                    />
                  </div>

                  <div v-else-if="item.subjectName == 'Bahasa Melayu'">
                    <img
                      src="../assets/img/iconbm.png"
                      width="50px"
                      class="mt-3"
                    />
                  </div>

                  <div v-else-if="item.subjectName == 'Pendidikan Islam'">
                    <img
                      src="../assets/img/iconislamic.png"
                      width="50px"
                      class="mt-3"
                    />
                  </div>

                  <div v-else-if="item.subjectName == 'Bahasa Arab'">
                    <img
                      src="../assets/img/iconarab.png"
                      width="50px"
                      class="mt-3"
                    />
                  </div>

                  <div v-else-if="item.subjectName == 'Perniagaan'">
                    <img
                      src="../assets/img/iconbusiness.png"
                      width="50px"
                      class="mt-3"
                    />
                  </div>

                  <div v-else>
                    <img
                      src="../assets/img/iconsub.png"
                      width="50px"
                      class="mt-3"
                    />
                  </div>
                </div>
                <div class="col-9">
                  <span
                    style="color: rgb(33 162 162)"
                    class="small ml-2 mr-2 mb-2"
                    >Subject</span
                  >
                  <h6 class="ml-2 mr-2 mb-2 text-black custom-font">
                    <strong>{{ item.subjectName }}</strong>
                  </h6>
                  <div>
                    <p class="ml-2 mr-2 text-black custom-font">
                      Total Quiz :
                      <strong>{{ item.totalQuizCount }}</strong> Quiz
                    </p>
                  </div>
                  <br />
                  <!-- <div class="float-right mt-2">
                    <CButtonGroup size="sm">
                      <CButton color="secondary">
                        <CIcon name="cil-trash"
                      /></CButton>
                      <CButton style="background:#00cdcd;color:#6d298a"
                        ><CIcon name="cil-chevron-right"
                      /></CButton>
                    </CButtonGroup>
                  </div>-->
                </div>
                <CCard
                  body-wrapper
                  class="bottom-center m-0"
                  style="background: #ebedef"
                >
                  <div class="bottom-view-right">
                    <span style="color: rgb(33 162 162)">
                      <strong>View</strong>
                    </span>
                    &nbsp;
                    <CIcon name="cil-chevron-right" />
                  </div>
                </CCard>
              </CRow>
            </CCard>

         </CCol>
        </CContainer>
      </CCol>
    </CCard>
  </div>
</template>
<style>
@import url("https://fonts.googleapis.com/css2?family=Rubik:wght@300");
</style>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import Mainlayout from "../containers/TheHeaderWebStudent.vue";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "QuizStudentDashboard",
  components: {
    PulseLoader,
    Mainlayout,
  },
  data() {
    return {
      backgroundBanner,
      // subjects: [],
      // grades: [],
      // SelectedSubject: "",
      // SelectedGrade: "",
      // Question: "",
      // SelectedTimer: "",
      quizStudList: [],
      SubmittedForm: false,
      Error: false,
      hasScrolledToBottom: false,
      QuizId: "",
    };
  },
  async mounted() {
    this.GetCheckStudentStatus();
    this.GetQuizStudentDetails();
    this.RefreshData();
  },
  computed: {},
  methods: {
    RefreshData()
    {
        this.GetCheckStudentStatus();
    this.GetQuizStudentDetails();
    },
    async GetQuizStudentDetails() {
      this.$API
        .get(
          this.$QuizStudentDetail + "?studentId=" + this.$route.query.studentId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.quizStudList = response.data;
          }
        });
    },
    GetCheckStudentStatus() {
      console.log(this.$route.query.studentId);
      if (
        this.$route.query.studentId == 0 ||
        this.$route.query.studentId == undefined
      ) {
        this.GotoPageStudent();
      } else {
        this.$API
          .get(
            this.$CheckStudentSubGraStat +
              "?studentId=" +
              this.$route.query.studentId,
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.quizList = response.data;
              if (this.quizList.length == 0) {
                this.GotoPageGrade();
              }
            }
          });
      }
    },
    GoToPageQuizList(subjectId) {
      this.$router.push(
        "/QuizStudentQuizList?studentId=" +
          this.$route.query.studentId +
          "&subjectId=" +
          subjectId +
          "&userId=" +
          this.$route.query.userId
      );
    },
     GotoPageQuiz() {
       console.log("test");
      this.$router.push("/QuizStudentDescription?quizId=" + this.QuizId + "&studentId=" +  this.$route.query.studentId + "&userId=" +  this.$route.query.userId);
    },
    GotoPageQuestionDescription() {
      this.$router.push(
        "/QuizStudentQuizList?subjectId=" +
          this.$route.query.subjectId +
          "&studentId=" +
          this.user.id +
          "&userId=" +
          this.$route.query.userId
      );
    },
    GotoPageStudent() {
      this.$router.push("/QuizStudent?userId=" + this.$route.query.userId);
    },
    GotoPageGrade() {
      this.$router.push(
        "/QuizGrade?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },
    
  },
};
</script>
<style>

input[type=text]:focus {
    z-index: auto;
}
</style>